import { useEffect, useState } from "react";
import InputData from "./InputData";
import CheckBox from "./CheckBox";
import Dropdown from "./Dropdown";
import {
  focusElement,
  inputOnEnter,
  selectedOptic,
  userData,
} from "../js/utils";
import { post } from "../js/post";
import moment from "moment";

export default function AdvancedWarehouseProductInfo({
  product,
  handleProductChange,
}) {
  const [ivaList, setIvaList] = useState([]);

  async function getIVAList() {
    const response = await post("ListarTiposIVA.php", {
      token: userData.token,
      idOptica: selectedOptic.id,
    });
    const list = response.tiposIVA.map((e) => ({
      id: e,
      text: e.toString(),
    }));
    setIvaList(list);
  }

  useEffect(() => {
    focusElement(525);
    getIVAList();
  }, []);

  return (
    <div className="cell combined-cells-5">
      <div
        className="opt-table-content grid-8"
        id="advanced-product-content-grid"
      >
        <div className="cell cell-label">PVP</div>
        <div className="cell">
          <InputData
            tabIndex={525}
            type="type-float2"
            size={0}
            input={product.pvp}
            onChange={(e) => {
              handleProductChange("pvp", e);
            }}
          ></InputData>
        </div>
        <div className="cell"></div>
        <div className="cell cell-label">IVA</div>
        <div className="cell">
          <Dropdown
            mandatory={true}
            optionList={ivaList}
            size={0}
            op={product.iva}
            onChange={(e) => {
              handleProductChange("iva", e.text);
            }}
          ></Dropdown>
        </div>
        <div className="cell"></div>
        <div className="cell cell-label">PMC</div>
        <div className="cell">
          <InputData
            inactive={true}
            type="type-float2"
            size={0}
            input={product.pmc}
            onChange={() => {}}
          ></InputData>
        </div>
        <div className="cell cell-label">PVP recomendado</div>
        <div className="cell combined-cells-4">
          <InputData
            tabIndex={526}
            type="type-float2"
            size={0}
            input={product.pvpRecomendado}
            onChange={(e) => {
              handleProductChange("pvpRecomendado", e);
            }}
          ></InputData>
        </div>
        <div className="cell"></div>
        <div className="cell cell-label">PMV</div>
        <div className="cell">
          <InputData
            inactive={true}
            type="type-float2"
            size={0}
            input={product.pmv}
            onChange={() => {}}
          ></InputData>
        </div>
        <div className="cell cell-label">Fecha oferta inicio</div>
        <div className="cell">
          <input
            type="datetime-local"
            max="9999-12-31T23:59"
            tabIndex={527}
            step={1}
            className="input-field input-cell"
            value={product.fechaOfertaInicio}
            onChange={(e) => {
              const value = e.target.value;
              handleProductChange(
                "fechaOfertaInicio",
                value === "" ? "" : moment(value).format("YYYY-MM-DD HH:mm:ss"),
              );
            }}
            onKeyUp={(e) => inputOnEnter(e)}
          ></input>
        </div>
        <div className="cell"></div>
        <div className="cell cell-label">Fin</div>
        <div className="cell">
          <input
            type="datetime-local"
            max="9999-12-31T23:59"
            tabIndex={528}
            step={1}
            className="input-field input-cell"
            value={product.fechaOfertaFin}
            onChange={(e) => {
              const value = e.target.value;
              handleProductChange(
                "fechaOfertaFin",
                value === "" ? "" : moment(value).format("YYYY-MM-DD HH:mm:ss"),
              );
            }}
            onKeyUp={(e) => inputOnEnter(e)}
          ></input>
        </div>
        <div className="cell"></div>
        <div className="cell cell-label">Margen comercial %</div>
        <div className="cell">
          <InputData
            inactive={true}
            type="type-float2"
            size={0}
            input={product.margenComercial}
            onChange={() => {}}
          ></InputData>
        </div>
        <div className="cell cell-label">PVP oferta</div>
        <div className="cell combined-cells-4">
          <InputData
            tabIndex={529}
            type="type-float2"
            size={0}
            input={product.pvpOferta}
            onChange={(e) => {
              handleProductChange("pvpOferta", e);
            }}
          ></InputData>
        </div>
        <div className="cell"></div>
        <div className="cell cell-label">Comisión %</div>
        <div className="cell">
          <InputData
            tabIndex={532}
            type="type-float2"
            size={0}
            input={product.comision}
            onChange={(e) => {
              handleProductChange("comision", e);
            }}
          ></InputData>
        </div>
        <div className="cell cell-label">Uds. precio especial</div>
        <div className="cell combined-cells-4">
          <button
            className="incdec-btn"
            onClick={() => {
              handleProductChange(
                "unidadesPvpEspecial",
                parseInt(product.unidadesPvpEspecial) > 2
                  ? parseInt(product.unidadesPvpEspecial) - 1
                  : parseInt(product.unidadesPvpEspecial),
              );
            }}
          >
            -
          </button>
          <InputData
            tabIndex={530}
            type="type-integer-min2"
            size={5}
            input={product.unidadesPvpEspecial}
            onChange={(e) => {
              handleProductChange("unidadesPvpEspecial", e);
            }}
            onBlur={(val) => {
              if (!val || parseInt(val) < 2)
                handleProductChange("unidadesPvpEspecial", 2);
            }}
          ></InputData>
          <button
            className="incdec-btn"
            onClick={() => {
              handleProductChange(
                "unidadesPvpEspecial",
                parseInt(product.unidadesPvpEspecial) + 1,
              );
            }}
          >
            +
          </button>
        </div>
        <div className="cell"></div>
        <div className="cell cell-label">Dto. máximo %</div>
        <div className="cell">
          <InputData
            tabIndex={533}
            type="type-float2"
            size={0}
            input={product.dtoMaximo}
            onChange={(e) => {
              handleProductChange("dtoMaximo", e);
            }}
          ></InputData>
        </div>
        <div className="cell cell-label">PVP especial</div>
        <div className="cell combined-cells-4">
          <InputData
            tabIndex={531}
            type="type-float2"
            size={0}
            input={product.pvpEspecial}
            onChange={(e) => {
              handleProductChange("pvpEspecial", e);
            }}
          ></InputData>
        </div>
        <div className="cell"></div>
        <div className="cell cell-label">Stock mínimo</div>
        <div className="cell">
          <InputData
            tabIndex={534}
            type="type-float"
            size={0}
            input={product.stockMinimo}
            onChange={(e) => {
              handleProductChange("stockMinimo", e);
            }}
          ></InputData>
        </div>

        <div className="cell cell-label">Descatalogado</div>
        <div className="cell">
          <div
            className="data-field c-pointer"
            onClick={() => {
              handleProductChange("descatalogado", !product.descatalogado);
            }}
          >
            <CheckBox
              tabIndex={535}
              active={product.descatalogado}
              onClick={() => {}}
            ></CheckBox>
          </div>
        </div>
        <div className="cell combined-cells-4"></div>
        <div className="cell cell-label">Sin control de stock</div>
        <div className="cell">
          <div
            className="data-field c-pointer"
            onClick={() => {
              handleProductChange("sinControlStock", !product.sinControlStock);
            }}
          >
            <CheckBox
              tabIndex={536}
              active={product.sinControlStock}
              onClick={() => {}}
            ></CheckBox>
          </div>
        </div>
      </div>
    </div>
  );
}
